import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { NgOptimizedImage } from '@angular/common';
import {
  getColumnKey,
  ImageThumbnailComponent,
  ImageThumbnailUnsupportedComponent,
  TableBodyNoReferenceCellComponent,
  TableColumn,
} from '@web/shared/ui';
import { isNotNil } from '@web/utils';
import { AdminBoxSaleCollectionFilter } from '../../models/admin-box-sale-collection-filter';
import { AdminBoxSaleCollectionItem } from '../../models/admin-box-sale-collection-item';
import { AdminBoxSaleStatusComponent } from '../admin-box-sale-status/admin-box-sale-status.component';

@Component({
  selector: 'app-admin-box-sale-list-custom-cell-template',
  imports: [
    AdminBoxSaleStatusComponent,
    ImageThumbnailComponent,
    ImageThumbnailUnsupportedComponent,
    NgOptimizedImage,
    TableBodyNoReferenceCellComponent,
  ],
  templateUrl: './admin-box-sale-list-custom-cell-template.component.html',
  styleUrl: './admin-box-sale-list-custom-cell-template.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AdminBoxSaleListCustomCellTemplateComponent {
  /* prettier-ignore */
  public readonly column = input.required<TableColumn<AdminBoxSaleCollectionItem, AdminBoxSaleCollectionFilter>>();
  /* prettier-ignore */
  public readonly model = input.required<AdminBoxSaleCollectionItem>();

  protected readonly getColumnKey = getColumnKey<AdminBoxSaleCollectionItem>;
  protected readonly isNotNil = isNotNil;
}
